import { render } from "./Footer.vue?vue&type=template&id=7ca69fff&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=7ca69fff&scoped=true&lang=css"

import exportComponent from "/Users/peilijun/Desktop/AgCloudWeb2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca69fff"]])

export default __exports__